import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
    selector: 'mark-answered-dialog',
    templateUrl: 'chat-mark-answered-dialog.component.html',
    standalone: false
})
export class ChatMarkAnsweredDialogComponent implements OnInit {
	@Input() public model: any;

	@Output() public save = new EventEmitter();
	@Output() public close = new EventEmitter();

    constructor() {}

	public ngOnInit() {
		setTimeout(() => {
			$('#txtComment textarea').focus();
		}, 100);
	}

}